import { PDFDocument, rgb } from "pdf-lib";

const REFERENCE_WIDTH = 164.409;
const REFERENCE_HEIGHT = 113.386;
const SIZE_TOLERANCE = 3;
const PDF_MIME_TYPES = new Set(["application/pdf", "application/x-pdf"]);

export function isPdfFile(file) {
  if (!file) return false;
  const type = String(file.type || "").toLowerCase();
  const name = String(file.name || "").toLowerCase();
  return PDF_MIME_TYPES.has(type) || name.endsWith(".pdf");
}

function formatDate(dateValue) {
  const [year, month, day] = String(dateValue || "").split("-");
  if (!year || !month || !day) {
    throw new Error("Выберите дату срока годности");
  }
  return `${day}.${month}.${year}`;
}

function assertStickerSize(page, pageIndex) {
  const { width, height } = page.getSize();
  const supported =
    Math.abs(width - REFERENCE_WIDTH) <= SIZE_TOLERANCE &&
    Math.abs(height - REFERENCE_HEIGHT) <= SIZE_TOLERANCE;

  if (!supported) {
    throw new Error(
      `Страница ${pageIndex + 1} имеет неподдерживаемый размер. Ожидается стикер 58 × 40 мм.`,
    );
  }
}

function canvasToPngBytes(canvas) {
  return new Promise((resolve, reject) => {
    canvas.toBlob(async (blob) => {
      if (!blob) {
        reject(new Error("Не удалось подготовить надпись со сроком годности"));
        return;
      }
      resolve(new Uint8Array(await blob.arrayBuffer()));
    }, "image/png");
  });
}

async function createExpiryLabelPng(dateText) {
  const canvas = document.createElement("canvas");
  canvas.width = 520;
  canvas.height = 210;
  const context = canvas.getContext("2d");

  if (!context) {
    throw new Error("Браузер не поддерживает подготовку надписи");
  }

  context.clearRect(0, 0, canvas.width, canvas.height);
  context.fillStyle = "#000000";
  context.textBaseline = "top";
  context.font = "56px Arial, sans-serif";
  context.fillText("Годен до:", 4, 5);
  context.font = "700 80px Arial, sans-serif";
  context.fillText(dateText, 4, 78);

  return canvasToPngBytes(canvas);
}

export async function editStickerPdf(file, expiryDate) {
  if (!file) throw new Error("Выберите PDF-файл");
  if (!isPdfFile(file)) {
    throw new Error("Можно загрузить только PDF-файл");
  }

  const pdf = await PDFDocument.load(await file.arrayBuffer());
  const pages = pdf.getPages();
  if (pages.length === 0) throw new Error("В PDF нет страниц");

  pages.forEach(assertStickerSize);

  const dateText = formatDate(expiryDate);
  const labelImage = await pdf.embedPng(await createExpiryLabelPng(dateText));

  pages.forEach((page) => {
    const { width, height } = page.getSize();
    const scaleX = width / REFERENCE_WIDTH;
    const scaleY = height / REFERENCE_HEIGHT;

    page.drawRectangle({
      x: 133 * scaleX,
      y: 0,
      width: width - 133 * scaleX,
      height: 29 * scaleY,
      color: rgb(1, 1, 1),
    });

    page.drawImage(labelImage, {
      x: 112 * scaleX,
      y: 5 * scaleY,
      width: 52 * scaleX,
      height: 21 * scaleY,
    });
  });

  const outputBytes = await pdf.save();
  return {
    blob: new Blob([outputBytes], { type: "application/pdf" }),
    pageCount: pages.length,
    formattedDate: dateText,
  };
}

export function buildStickerFilename(originalName, expiryDate) {
  const baseName = String(originalName || "стикеры").replace(/\.pdf$/i, "");
  return `${baseName}_срок_годности_${formatDate(expiryDate).replaceAll(".", "-")}.pdf`;
}
